import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';

import BriefIcon from './layout/hero/BriefIcon';
import GalleryGridx1 from './layout/portfolio/GalleryGridx1';
import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx3 from './layout/portfolio/ImageGridx3';
import VideoGridFront from './layout/portfolio/VideoGridFront';
import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

import PenIcon from './asset/PenIcon';
import monoFront from './img/monoshift/MercBClass4.mp4';

// websites
import monoshiftCover from './img/monoshift/monoshift_cover@2x.jpg';

// BClass
import BClass_1 from './img/monoshift/MercBClass2@2x.jpg';
import BClass_2 from './img/monoshift/MercBClass1@2x.jpg';
import BClass_3 from './img/monoshift/MercBClass3@2x.jpg';

// LG
import LG_1 from './img/monoshift/monoshift@2x.jpg';
// cresyn
import cresyn_1 from './img/monoshift/cresyn1@2x.jpg';
import cresyn_2 from './img/monoshift/cresyn2@2x.jpg';

// Summary
const companyInfo = {
  title: "The extraordinary campaign makers.",
  name: "Monoshift",
  themeColor: "#020B14",
  themeTextColor: "white",
  frontImage: monoFront,
  role: "Intern Designer",
  fields: "Advertising, Facebook Marketing, Web design",
  time: "March 2012 – July 2012",
}

// how I stated working at the company
const workContent =
  {
    description: "When I was a university student, I emailed Monoshift to say how much I loved their work. A few hours later, the director emailed me back and asked whether I was interested in working with them as an intern. That was how I started working at Monoshift – one of the best design studios in South Korea for interactive design."
  };

// Project case study
const LG3D = {
  summary: "Who are Monoshift?",
  titleIcon: PenIcon,
  title: "Exploring art and technology.",
  paragraph: "Monoshift's main goal was to create positive influence by designable media. By 'designable', it could be the lines of code, pixels on unique display, or anything! At Monoshift, the designer and coder were often the same person. The company's motto influenced me a lot after I finished my internship.",
  themeColor: '#000000',
  textColor: '',
}

const Bclass = {
  summary: "WORKING AS AN INTERN",
  titleIcon: PenIcon,
  title: "I did miscellanous design chores whilst learning design from scratch.",
  paragraph: "Precision was the key to creating a perfect experience. As an intern, I was checking again and again to make sure everything is okay. The synchronisation of mapped images, subtitles, for creating labour-intensive isometric background scenes. \n\nDespite how it sounds, I really enjoyed experiencing the process as much as designing itself. Also, I remember how I appreciated it when they chose some of my work in the final campaign.",
  themeColor: "#000B16",
  textColor: '#ffffff',
}


const cresyn = {
  summary: "Cresyn website",
  titleIcon: PenIcon,
  title: "In the last part of the internship, I got a chance to design a website.",
  paragraph: "Later in my internship, I was allowed to create variations for making websites. The time was usually quite tight, and I had to train myself to intepret the visual language based on what the senior designer has defined. It trained me how to interpret design guidlines and how to create a consistent look and feel.",
  themeColor: '#ffffff',
  textColor: '',
}

const metatag = {
  title: "Portfolio ✴︎ " + companyInfo.name,
  author: "Jinju Jang",
  url: "http://jinju.io/monoshift",
  description: companyInfo.paragraph,
  image: "http://jinju.io" + BClass_3
}

class PortfolioMonoShift extends Component {
  render() {
    return (
      <div>
        <Navigation />
        {/*Meta data*/}
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{metatag.title}</title>
          <meta name="author" content={metatag.author}/>
          <meta name="description" content={metatag.description}/>

          {/*-- Google / Search Engine Tags --*/}
          <meta itemprop="name" content={metatag.title}/>
          <meta itemprop="description" content={metatag.description}/>
          <meta itemprop="image" content={metatag.image}/>

          {/*-- Open Graph / Facebook --*/}
          <meta property="og:url" content={metatag.url}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={metatag.title} />
          <meta property="og:description" content={metatag.description}/>
          <meta property="og:image" content={metatag.image}/>

          {/*-- Twitter --*/}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={metatag.title}/>
          <meta name="twitter:description" content={metatag.description}/>
          <meta name="twitter:image" content={metatag.image}/>
       </Helmet>
        {/*Front page*/}
        <VideoGridFront
          first={companyInfo.frontImage}
          title={companyInfo.title}
          themeColor={companyInfo.themeColor}
          textColor={companyInfo.themeTextColor}/>

        {/*Position summary*/}
        <ProjectInfo
          title={companyInfo.name}
          role={companyInfo.role}
          fields={companyInfo.fields}
          description={workContent.description}
          time={companyInfo.time}/>

        <GalleryGridx1
          first={LG_1}/>

        <ImageGridx1
          first={monoshiftCover}
          innerDescription={<BriefIcon
            summary={LG3D.summary}
            titleIcon={<PenIcon
            color={LG3D.textColor}/>}
            title={LG3D.title}
            paragraph={LG3D.paragraph}
            textColor={LG3D.textColor}/>}
            />

        {/*----- Benz B class ------*/}
        <ImageGridx3
          first={BClass_1}
          second={BClass_2}
          third={BClass_3}
          innerDescription={<BriefIcon summary={Bclass.summary} titleIcon={<PenIcon color={Bclass.textColor}/>}
          title={Bclass.title}
          caption={Bclass.title}
          paragraph={Bclass.paragraph} textColor={Bclass.textColor}/>}themeColor={Bclass.themeColor} showTriangle/>

        {/*----- Cresyn ------*/}
        <GalleryGridx1
          first={cresyn_1}
          innerDescription={<BriefIcon summary={cresyn.summary}
          titleIcon={<PenIcon color={cresyn.textColor}/>}
          title={cresyn.title}
          paragraph={cresyn.paragraph}
          textColor={cresyn.textColor}/>}
          themeColor={cresyn.themeColor} true/>
        <ImageGridx1 first={cresyn_2} />
        <NextUp
          previous="Generative Art"
          previousURL="/personal"
          next="Outware Mobile"
          nextURL="/outware"
        />
        <WarpLarge />
        <Footer/>
      </div>
    );
  }
}

export default PortfolioMonoShift;



// WEBPACK FOOTER //
// ./src/PortfolioMonoShift.js